import React from "react";

const relatedAreas = [
  {
    href: "/skill-areas/marketing-creativity-sales",
    label: "Marketing, Creativity & Sales",
  },
  {
    href: "/skill-areas/ai-innovation",
    label: "AI & Innovation",
  },
  {
    href: "/skill-areas/leadership-wellbeing",
    label: "Leadership & Wellbeing",
  },
  {
    href: "/courses",
    label: "All 40+ courses",
  },
];

const Related = () => {
  return (
    <section className="related" aria-labelledby="related-title">
      <div className="container">
        <h2 id="related-title">Explore other skill areas</h2>

        <div className="related-row">
          {relatedAreas.map((area) => (
            <a key={area.href} href={area.href} className="related-pill">
              {area.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Related;
